export const getSeoStuffMaybe = seo => {
  let seoImagesMaybe = {};
  if (seo?.share_image?.image?.formats?.thumbnail?.url) {
    const i = [
      {
        url: `${process.env.REACT_APP_STRAPI_BACKEND_URL}${seo.share_image.image.formats.thumbnail.url}`,
        width: seo.share_image.image.formats.thumbnail.width,
        height: seo.share_image.image.formats.thumbnail.height,
      },
    ];
    seoImagesMaybe = {
      facebookImages: i,
      twitterImages: i,
    };
  }
  const keywordsMaybe = seo?.meta_keywords ? { keywords: seo?.meta_keywords } : {};
  const extraMetaMaybe = seo?.meta_extra ? { extraMeta: seo?.meta_extra } : {};
  return { ...seoImagesMaybe, ...keywordsMaybe, ...extraMetaMaybe };
};
